import { itemService } from 'services/Item/itemService';

export const isOfferActive = async (offerId: number, itemId: number) => {
  const { data: offer } = await itemService.fetchMyLastOffer(itemId);
  return offer.id === offerId && offer.status === 'ACCEPTED';
};
